import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import history from '../../../core/history'
import Header from './Header'
import { administratorLogOut } from '../../../features/AdministrationLogin/administrationLoginContainerActions'
import { actions as navigationActions } from '../navigationLinksContainerReducerActions'
import { actions as editorContainerActions } from '../../../features/AdviserProfileEditor/AdviserProfileEditorContainer/adviserProfileEditorContainerActions'
import { bindActionCreators } from 'redux'
import 'bootstrap/dist/css/bootstrap.min.css';

class HeaderContainer extends React.Component {
  static propTypes = {
    administratorLogOut: PropTypes.func.isRequired,
    ifaLogOut: PropTypes.func.isRequired,
    getNavigationLinks: PropTypes.func.isRequired,
    onSetSidebarOpen: PropTypes.func.isRequired,
    onMouseEnterDropdown: PropTypes.func.isRequired,
    onMouseLeaveDropdown: PropTypes.func.isRequired,
    onMouseClickDropdown: PropTypes.func.isRequired,
    navigationLinks: PropTypes.object,
    administratorLoggedIn: PropTypes.bool.isRequired,
    administratorName: PropTypes.string,
    adviserLoggedIn: PropTypes.bool.isRequired,
    navigationLinksFetched: PropTypes.bool.isRequired,
    publicPortalUrl: PropTypes.string.isRequired,
    adviserName: PropTypes.string,
    activeMenu: PropTypes.string,
    adviserId: PropTypes.number
  }

  constructor (props) {
    super(props)
    this.goToProfile = this.goToProfile.bind(this)
    this.logout = this.logout.bind(this)
    this.onSetSidebarOpen = this.onSetSidebarOpen.bind(this)
    this.onMouseEnterDropdown = this.onMouseEnterDropdown.bind(this)
    this.onMouseLeaveDropdown = this.onMouseLeaveDropdown.bind(this)
    this.onMouseClickDropdown = this.onMouseClickDropdown.bind(this)
  }

  componentDidMount () {
    if (!this.props.navigationLinksFetched) {
      this.props.getNavigationLinks()
    }
  }

  goToAllanGrayHome () {
    history.go('https://www.allangray.co.za/')
  }

  goToFindAnIFA () {
    history.push('/')
  }

  goToAdviserDataDump () {
    history.push('/adviser-datadump')
  }

  goToPendingApprovalProfiles () {
    history.push('/administration/pendingapprovalAdviserProfiles')
  }

  goToAdministrators () {
    history.push('/administration/administrators')
  }

  goToProfile () {
    history.push(`/adviser/${this.props.adviserId}/profile/edit`)
  }

  goToAdviserWhitelisting () {
    history.push('/administration/whitelisting')
  }

  goToConfigureRateLimiter () {
    history.push('/administration/configureRateLimiter')
  }

  onSetSidebarOpen (open) {
    this.props.onSetSidebarOpen(open)
  }

  logout () {
    if (this.props.administratorLoggedIn) this.props.administratorLogOut()
    if (this.props.adviserLoggedIn) this.props.ifaLogOut()
    this.goToFindAnIFA()
  }

  onMouseEnterDropdown (menuName) {
    this.props.onMouseEnterDropdown(menuName)
  }

  onMouseLeaveDropdown (menuName) {
    this.props.onMouseLeaveDropdown(menuName)
  }

  onMouseClickDropdown (menuName) {
    this.props.onMouseClickDropdown(menuName)
  }

  render () {
    return (
      <Header
        activeMenu={this.props.activeMenu}
        onSetSidebarOpen={this.onSetSidebarOpen}
        activeAudience={'New clients'}
        publicPortalUrl={this.props.publicPortalUrl}
        navigationLinksFetched={this.props.navigationLinksFetched}
        audiences={this.props.navigationLinks?.Audiences}
        mainMenu={this.props.navigationLinks?.MainMenu}
        goToFindAnIFA={this.goToFindAnIFA}
        goToAllanGrayHome={this.goToAllanGrayHome}
        goToPendingApprovalProfiles={this.goToPendingApprovalProfiles}
        goToAdministrators={this.goToAdministrators}
        goToAdviserWhitelisting={this.goToAdviserWhitelisting}
        goToConfigureRateLimiter={this.goToConfigureRateLimiter}
        goToProfile={this.goToProfile}
        goToAdviserDataDump={this.goToAdviserDataDump}
        onMouseEnterDropdown={this.onMouseEnterDropdown}
        onMouseLeaveDropdown={this.onMouseLeaveDropdown}
        onMouseClickDropdown={this.onMouseClickDropdown}
        userLoggedIn={this.props.administratorLoggedIn || this.props.adviserLoggedIn}
        administratorLoggedIn={this.props.administratorLoggedIn}
        userName={this.props.administratorName || this.props.adviserName}
        adviserId={this.props.adviserId}
        logout={this.logout} />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    administratorLoggedIn: state.administrationLoginContainer.loginSucceeded,
    administratorName: state.administrationLoginContainer.administratorName,
    adviserLoggedIn: state.adviserProfileEditorContainer.adviserIsLoggedIn,
    adviserName: state.adviserProfileEditorContainer.adviserName,
    adviserId: state.adviserProfileEditorContainer.profile.adviserId,
    navigationLinks: state.navigationLinksContainer.navigationLinks,
    activeMenu: state.navigationLinksContainer.activeMenu,
    navigationLinksFetched: state.navigationLinksContainer.navigationLinksFetched,
    publicPortalUrl: state.navigationLinksContainer.publicPortalUrl
  }
}

const mapDispatchToProps = (dispatch) => {
  const { login } = editorContainerActions
  return bindActionCreators({
    administratorLogOut: administratorLogOut,
    ifaLogOut: login.logAdviserOut,
    getNavigationLinks: navigationActions.get.navigationLinks,
    onSetSidebarOpen: navigationActions.set.sidebarOpen,
    onMouseEnterDropdown: navigationActions.on.mouse.enter,
    onMouseLeaveDropdown: navigationActions.on.mouse.leave,
    onMouseClickDropdown: navigationActions.on.mouse.click
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(HeaderContainer)
